import React from 'react';
import { useInternals } from '../../context/internalContext';

// Link de documento protegido: no clique baixa pela rota binary (com token) e abre em nova aba.
// Mantém <a> pra preservar o estilo dos links existentes; o href só serve de referência.
const BinaryFileLink = ({ resource, id, field, children, className, style, title }) => {
  const { getBinaryFileUrl, openBinaryFile } = useInternals();

  if (!resource || !id) return null;

  const handleClick = (event) => {
    event.preventDefault();
    openBinaryFile({ resource, id, field });
  };

  return (
    <a
      href={getBinaryFileUrl(resource, id, field)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      title={title}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

export default BinaryFileLink;
